import React, { useState } from "react";
import { LocalizationProvider } from "./LocalizationContext";
import Home from "./Components/Home/Home";
import Slider from "./Components/Slider/Slider";
import {SelectionProvider} from "./SelectionContext";
import { NavigationProvider } from "./NavigationContext";
const App = () => {

    return (
        <LocalizationProvider>
            <SelectionProvider>
                <NavigationProvider>
                    <div>
                        <Slider />
                    </div>
                </NavigationProvider>
            </SelectionProvider>

        </LocalizationProvider>
    );
};

export default App;